export enum ReorderDelayReason {
  None = 0,
  OverdueInvoice = 1,
  NoIdent = 2,
  MultipleReorders = 3,
  Other = 4,
  AddressUnconfirmed = 5,

}
